<div class="relative w-full overflow-hidden hidden md:block mt-[80px]">
    <img src="assets/img/event-calendar/event-calendar-connect.jpg" alt="Desktop Image"
         class="w-full h-auto object-contain">
</div>

<div class="relative w-full overflow-hidden flex md:hidden mt-[80px]">
    <img src="assets/img/event-calendar/event-calendar-mobile-banner.jpg" alt="Mobile Image"
         class="w-full h-auto object-contain">
</div>

<div class="flex items-start justify-center bg-gray-50 aarni-font">
    <div class="flex flex-col lg:flex-row gap-4 p-2 w-full max-w-7xl">
        <section class="w-full">
            <div class="flex-1 shadow-lg border-2 border-gray-200 bg-white">
                <div class="space-y-6">
                    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 p-4">
                        <div
                            *ngFor="let event of events"
                            (click)="openModal(event)"
                            class="cursor-pointer bg-white rounded-2xl shadow-lg overflow-hidden relative w-full"
                        >
                            <div class="relative w-full https://www.educationmitra.in/your-guide/consult-your-guideh-52 overflow-hidden">
                                <img
                                    [src]="event.images[0]"
                                    [alt]="event.title"
                                    class="w-full h-full object-cover"
                                />
                            </div>
                            <div class="p-4 relative h-[150px]">
                                <div
                                    *ngIf="event?.date"
                                    class="absolute -top-6 left-4 bg-red-500 text-white text-sm font-semibold px-4 py-2 rounded-full"
                                >
                                    {{ event.date }}
                                </div>
                                <h3 class="text-md md:text-lg font-semibold text-gray-800 mb-12">
                                    {{ event.title }}
                                </h3>
                                <div class="absolute bottom-4 right-4">
                                    <div
                                        class="w-8 h-8 flex items-center justify-center rounded-full border-2 border-pink-500 text-pink-500">
                                        ➜
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div
                        *ngIf="selectedEvent"
                        class="fixed inset-0 top-16 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4"
                    >
                        <div
                            class="bg-white w-full max-w-6xl h-[70vh] md:h-[80vh] p-6 rounded-lg shadow-xl relative overflow-hidden"
                        >
                            <button
                                (click)="closeModal()"
                                class="absolute top-2 right-2 text-gray-600 hover:text-red-500 text-2xl md:text-3xl font-bold"
                            >
                                &times;
                            </button>
                            <div *ngIf="selectedEvent?.instaLink" class="w-full flex justify-center">
                                <div class="w-full max-w-[340px] md:max-w-[420px] max-h-[70vh] md:max-h-full overflow-y-auto">
                                    <blockquote
                                        class="instagram-media w-full"
                                        [attr.data-instgrm-permalink]="selectedEvent.instaLink"
                                        data-instgrm-version="14"
                                        style="background:#FFF; border:0; margin: 1rem auto; width: 100%;"
                                    ></blockquote>
                                </div>
                            </div>
                            <div *ngIf="!selectedEvent?.instaLink && selectedEvent?.images?.length > 1" class="relative h-2/3 w-full overflow-hidden rounded-lg">
                                <img
                                    *ngFor="let img of selectedEvent.images; let i = index"
                                    [src]="img"
                                    [alt]="selectedEvent.title"
                                    [class.hidden]="i !== selectedEvent.activeImageIndex"
                                    class="absolute inset-0 w-full h-full object-cover md:object-contain transition-opacity duration-500"
                                />
                                <button (click)="prevImage(selectedEvent, $event)" class="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white/70 md:bg-black text-black md:text-white rounded-full p-2 z-10 text-2xl font-bold">
                                    ‹
                                </button>
                                <button (click)="nextImage(selectedEvent, $event)" class="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white/70 md:bg-black text-black md:text-white rounded-full p-2 z-10 text-2xl font-bold">
                                    ›
                                </button>
                            </div>
                            <div *ngIf="!selectedEvent?.instaLink && selectedEvent?.images?.length === 1" class="h-2/3 w-full overflow-hidden">
                                <img
                                    [src]="selectedEvent.images[0]"
                                    [alt]="selectedEvent.title"
                                    class="w-full h-full object-cover"
                                />
                            </div>
                            <div class="h-1/3 overflow-y-auto thin-scrollbar p-4" *ngIf="!selectedEvent?.instaLink">
                                <h2 class="text-xl font-bold mt-2">{{ selectedEvent.title }}</h2>
                                <p class="mt-1 text-sm text-gray-600">{{ selectedEvent.date }}</p>
                                <p class="mt-4 text-gray-700 text-justify"
                                   [innerHTML]="selectedEvent.description"></p>
                            </div>
                          <!--  <div
                                *ngIf="selectedEvent.images.length > 1"
                                class="relative h-2/3 w-full overflow-hidden rounded-lg"
                            >
                                <img
                                    *ngFor="let img of selectedEvent.images; let i = index"
                                    [src]="img"
                                    [alt]="selectedEvent.title"
                                    [class.hidden]="i !== selectedEvent.activeImageIndex"
                                    class="absolute inset-0 w-full h-full object-cover md:object-contain transition-opacity duration-500"
                                />
                                <button
                                    (click)="prevImage(selectedEvent, $event)"
                                    class="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white/70 md:bg-black  text-black md:text-white rounded-full p-2 z-10 text-2xl font-bold"
                                >
                                    ‹
                                </button>
                                <button
                                    (click)="nextImage(selectedEvent, $event)"
                                    class="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white/70 md:bg-black text-black md:text-white rounded-full p-2 z-10 text-2xl font-bold"
                                >
                                    ›
                                </button>
                            </div>
                            <div
                                *ngIf="selectedEvent.images.length === 1"
                                class="h-2/3 w-full overflow-hidden"
                            >
                                <img
                                    [src]="selectedEvent.images[0]"
                                    [alt]="selectedEvent.title"
                                    class="w-full h-full object-cover"
                                />
                            </div>
                            <div class="h-1/3 overflow-y-auto thin-scrollbar p-4">
                                <h2 class="text-xl font-bold mt-2">{{ selectedEvent.title }}</h2>
                                <p class="mt-1 text-sm text-gray-600">{{ selectedEvent.date }}</p>
                                <p class="mt-4 text-gray-700 text-justify"
                                   [innerHTML]="selectedEvent.description"></p>
                            </div>-->
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</div>


